import { createFileRoute, Outlet } from '@tanstack/react-router';

// Layout for the /cli/* routes. It must render an <Outlet/> (not a page) so
// child routes like /cli/dns-setup mount — the connect-CLI page lives at the
// /cli index route (cli.index.tsx).
export const Route = createFileRoute('/cli')({
  component: Outlet,
});
